import React from 'react';
import { Stack } from '@mui/material';

const TrialWelcomeCta: React.FC = () => <Stack spacing={3} alignItems="center" sx={{ mt: 4 }} />;

export default TrialWelcomeCta;
